import { PersonalizeEventsClient, PutEventsCommand } from "@aws-sdk/client-personalize-events"
import { fromCognitoIdentityPool } from "@aws-sdk/credential-providers"
import { sendGAEvent } from "@next/third-parties/google"

import { AWS_IDENTITY_POOL_ID, AWS_REGION, PSEUDO_ID_COOKIE } from "@lib/constants"
import { getSessionCookie } from "@lib/util/get-session-cookie-client"

export type AnalyticEventName =
  | "WEB_RETAIL_FLOW"
  | "SIGNUP_FLOW_START"
  | "SIGNUP_FLOW_PAGE_VIEW"
  | "SIGNUP_SUCCESS"
  | "SELECT_ITEM"
  | "VIEW_ITEM"
  | "VIEW_ITEM_LIST"
  | "VIEW_CART"
  | "BEGIN_CHECKOUT"
  | "WEB_SIGNUP_COMPLETE"
  | "LOAN_OPTIONS_DISPLAY"
  | "SELECT_LOAN_OPTION"
  | "SUBMIT_ADDRESS"
  | "SUBMIT_ADDRESS_ERROR"
  | "VERIFICATION_STACK"
  | "ONFIDO_VERIFICATION_COMPLETE"
  | "ONFIDO_VERIFICATION_ERROR"
  | "PURCHASE"
  | "PAYMENT_METHOD_SELECTED"
  | "PARTIAL_PAYMENT_SCREEN_RENDERED"
  | "SIGNUP_AND_ORDER_FLOW_STEP"
  | "VIEW_UNAVAILABLE_PRODUCT_PAGE"
  | "INSTALLMENT_OPTION_SELECTED"
  | "VIEW_CAROUSEL"
  | "VIEW_PILL"
  | "VIEW_NAVBAR"
  | "SELECT_PILL"
  | "XP_INCLUSION"
  | "REMOVE_CART_ITEM"
  | "FILTER_MENU_CLICK"
  | "FILTER_OPTION_CLICK"
  | "SORT_MENU_CLICK"
  | "SORT_OPTION_CLICK"
  | "CONTINUE_CHECKOUT"
  | "PARTIAL_PAYMENT_FORM_COMPLETED"
  | "INSTALLMENT_SELECTED"
  | "PARTIAL_PAYMENT_FORM_VALIDATION_ERROR"
  | "PARTIAL_PAYMENT_CONFIRM_PAYMENT_ERROR"
  | "PARTIAL_PAYMENT_PAYMENT_CONFIRMED"
  | "PARTIAL_PAYMENT_ERROR_CREATING_CARD"
  | "PARTIAL_PAYMENT_COMPLETING_CART_FOR_VERIFIED_USER"
  | "PARTIAL_PAYMENT_COMPLETED"

export const sendGoogleAnalyticsEvent = (name: AnalyticEventName | string, payload: Record<string, any> | null = null) => {
  sendGAEvent("event", name.toLowerCase(), {
    storefront_session_id: getSessionCookie(PSEUDO_ID_COOKIE),
    source: "store_front",
    ...(payload || {}),
  })
}

export const sendPersonalizeAnalyticsEvent = async (eventType: string, itemId: string, impressions: Array<string>) => {
  const creds = fromCognitoIdentityPool({
    identityPoolId: AWS_IDENTITY_POOL_ID,
    clientConfig: { region: AWS_REGION },
  })

  const userId = getSessionCookie(PSEUDO_ID_COOKIE) || undefined

  const timestamp = Date.now()
  const eventId = `${eventType}|${userId}|${itemId}|${timestamp}`

  const client = new PersonalizeEventsClient({
    credentials: creds,
    region: AWS_REGION,
  })

  await client.send(
    new PutEventsCommand({
      trackingId: "598a258e-e5ea-40f6-8838-dd5db5f027f4",
      sessionId: userId,
      userId: userId,
      eventList: [
        {
          eventId: eventId,
          eventType: eventType,
          itemId: itemId,
          impression: impressions.length > 0 ? impressions.slice(-25) : undefined,
          sentAt: new Date(timestamp),
        },
      ],
    })
  )
}
